module.exports = "/images/vendor/flag-icon-css/flags/4x3/pt.svg?b908edaecfb2ef51ac70b6bf7457ef2c";